import * as React from 'react';
import { Link as _GatsbyLink } from 'gatsby';
import * as styles from './Header.module.scss';

import { ReactComponent as NavbarOpenSvg } from './icon/navbar-open.svg';
import { ReactComponent as NavbarCloseSvg } from './icon/navbar-close.svg';
import { ReactComponent as DevTechWordmark } from './icon/devtech-wordmark.svg';
import { ReactComponent as NavigationArrowSvg } from './icon/navigation-arrow.svg';

type HeaderProps = {
  location: Location;
};

const controlId = 'toggle-navigation';

const Header: React.FC<HeaderProps> = ({ location }) => {
  const navigationData: {label: string, link: string}[] = [
    {
      label: '스토리',
      link: 'https://tech-story.devsisters.com/',
    },
    {
      label: '기술블로그',
      link: '/',
    },
    {
      label: 'GitHub',
      link: 'https://github.com/devsisters',
    },
    {
      label: '채용',
      link: 'https://careers.devsisters.com/',
    },
  ]

  return (
    <header className={styles.container}>
      <input type="checkbox" id={controlId} className={styles.control} />
      <nav className={styles.navigationBar}>
        <DevTechWordmark className={styles.logo} />
        <label htmlFor={controlId} className={styles.navigationControl}>
          <NavbarOpenSvg className={styles.open} />
          <NavbarCloseSvg className={styles.close} />
        </label>
        <ul className={styles.navigationMenu}>
          {navigationData.map((item) => (
            <li key={item.link} className={`${styles.navigationMenuItem} ${item.link === location.pathname && styles.active}`}>
              {
                item.link.startsWith('http') ? (
                  <a href={item.link} rel="noopener" className={styles.link}>{item.label}<NavigationArrowSvg className={styles.navigationArrowIcon} /></a>
                ) : (
                  <_GatsbyLink to={item.link} className={styles.link}>{item.label}</_GatsbyLink>
                )
              }
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
